module.exports = __webpack_public_path__ + "static/media/motorway.9b9ea845.jpg";